import '../theme/apim-chart-theme.scss';
import Highcharts from 'highcharts';
import moreInit from 'highcharts/highcharts-more';
import boostInit from 'highcharts/modules/boost';
import exportingInit from 'highcharts/modules/exporting';
import gaugeInit from 'highcharts/modules/solid-gauge';
import heatmapInit from 'highcharts/modules/heatmap';
import { Chart } from 'highcharts-vue';

moreInit(Highcharts);
boostInit(Highcharts);
exportingInit(Highcharts);
gaugeInit(Highcharts);
heatmapInit(Highcharts);

export { Highcharts, Chart };
